import React, { Component,useEffect, useState } from "react";
import './board.css';
import { Link } from 'react-router-dom';
import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';

const Board = () => {
  const [BoardData, setBoardData] = useState(null);
  const [BoardLoading, setBoardLoading] = useState(true);
  const [errorBoard, setBoardError] = useState(null);

  useEffect(() => {
    const fetchBoardData = async () => {
      try {
        const response = await Axios.get(`${URL}api/Board/getboardsDataPicture`);
        console.log('Response:', response.data);
        setBoardData(response.data);
        setBoardLoading(false);
      } catch (error) {
        console.log('Error:', error);
        setBoardError(error);
        setBoardLoading(false);
      }
    };

    fetchBoardData();
  }, []);

  if (BoardLoading) {
    return <div>Loading...</div>;
  }

  if (errorBoard) {
    return <div>Error: {errorBoard.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;
              <a href="board" className="a-breadcrumbs">คณะกรรมการ</a>
            </div>
          </div>
        </div>
      </section>

      <section className="page-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-md-offset-1">
              <h2 className="title-section mb-0 mt-0 text-center">
                <span>คณะกรรมการดำเนินการ</span>
              </h2>
              <div className="divider mb-20 mt-25 gray" />
            </div>
          </div>

          <div className="row mt-0 cws-multi-col" style={{ display: "flex", justifyContent: "center" }}>
            {BoardData && BoardData.attachfile ? (
              <div className="profile-item" style={{border: 0}}>
                <div className="pic" style={{ display: "flex", justifyContent: "center" }}>
                  <img 
                    src={`${IMGPATHS}img/Board/${BoardData.attachfile}`}
                    style={{
                      maxWidth: '80%', 
                      border: '1px solid #e6e6e6', 
                      borderRadius: 8
                    }}
                    alt="Board"
                  />
                </div>
              </div>
            ) : (
              <div className="col-12 text-center">
                <p>ไม่พบข้อมูล</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Board;